<template>
  <v-layout row wrap class="pt-4">
    <v-flex xs6 offset-xs3>
      <v-toolbar flat color="white">
        <v-toolbar-title>Отделы</v-toolbar-title>
        <v-btn absolute dark fab top right color="primary" @click="$refs.dialog.create()">
          <v-icon>add</v-icon>
        </v-btn>
        <v-layout row>
          <v-flex xs4 offset-xs8>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Поиск"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="departments"
        :search="search"
        rows-per-page-text="Отображать"
        class="elevation-10"
        sort-icon="fa-angle-up"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-edit-dialog
              large
              lazy
              save-text="Сохранить"
              cancel-text="Отмена"
              @save="update(props.item.id, props.item.name)"
            > {{ props.item.name }}
              <template v-slot:input>
                <v-text-field
                  v-model="props.item.name"
                  :rules="[required]"
                  label="Название"
                  single-line
                ></v-text-field>
              </template>
            </v-edit-dialog>
          </td>
        </template>
        <template slot="no-data">
          <v-alert :value="true" color="error" icon="warning">
            Данных не обнаружено.
          </v-alert>
        </template>
        <template slot="pageText" slot-scope="props">
          Страница {{ props.pageStart }} из {{ props.pageStop }} всего {{ props.itemsLength }}
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning">
          По запросу "{{ search }}" ничего не найдено.
        </v-alert>
      </v-data-table>
      <department-dialog ref="dialog"/>
    </v-flex>
  </v-layout>
</template>

<script>
  import DepartmentDialog from './Department-dialog'

  export default {
    data() {
      return {
        search: '',
        dialog: false,
        headers: [{text: 'Название', align: 'left', value: 'name'}],
        required: value => !!value || 'Название не заполнено.'
      }
    },
    methods: {
      async update (id, name) {
        await this.$store.dispatch('updateDepartment', {id, name})
      }
    },
    computed: {
        departments() {
          return this.$store.getters.departments
        }
    },
    components: {
      DepartmentDialog
    }
  }
</script>
